
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddFreight {
        warehouseInfoId: number;
        storeId?: number;
        whetherStock: boolean;
        site: number;
        cargoCategory: number;
        beginTime?: Date;
        endTime?: Date;
        isEffective: boolean;
        firstWeight: number;
        firstWeightPrice: number;
        inputWeight: number;
        continueWeight: number;
        continueWeightCost: number;
        bulkyParameter: number;
        inputLong: number;
        inputWidth: number;
        inputHigh: number;
    }
    @Component
    export default class CreatefreightModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        freight: AddFreight = new AddFreight();
        selectDate: string = "";
        selectDates: string = "";
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        storeaddressList: Array<storeaddressInfo> = [];
        cargoCategoryType = Enums.CargoCategoryType;
        whetherAbroadList = Enums.WhetherAbroadStatus;
        siteType = Enums.SiteSType;
        addLoding = false;
        amountTotal: string = '';;
        isDisplays: boolean = false;
        isDisplayx: boolean = true;
        created() {
            this.getCity();
        }
        async calculation() {
            //var total = Math.ceil((that.inputweight - that.firstWeight) / that.continueWeight) * that.continueWeightCost + that.firstWeightPrice;
            await this.$store.dispatch({
                type: 'mainlandfeightinfo/GetFreight',
                data: this.freight
            })
            this.amountTotal = this.$store.state.mainlandfeightinfo.total;
        }
        signFor() {
            this.save();
        }
        changestatus(a: any) {

            if (a == true) {
                this.getData();
                this.isDisplays = true;
                this.isDisplayx = false;
            }
            else {
                this.isDisplays = false;
                this.isDisplayx = true;
            }
        }   
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            //a.id = null;
            //a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            //this.storeaddressList.push(a);

        }
        save() {
            (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    if (this.freight.storeId) {
                        this.freight.warehouseInfoId = 0;
                    }
                    await this.$store.dispatch({
                        type: 'mainlandfeightinfo/Add',
                        data: this.freight
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.freightCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.freight.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.freightCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        freightRule = {

            warehouseId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            firstWeight: [
                { required: true, message: '首重不能为空，单位为g', trigger: 'blur' }
            ],
            firstWeightPrice: [
                { required: true, message: '首重价格不能为空', trigger: 'blur' }
            ],
            continueWeight: [
                { required: true, message: '续重不能为空，单位为g', trigger: 'blur' }
            ],
            continueWeightCost: [
                { required: true, message: '续重费用不能为空', trigger: 'blur' }
            ],
            bulkyParameter: [
                { required: true, message: '体积重参数不能为空', trigger: 'blur' }
            ],
            beginTime: [
                { required: true, message: '日期不能为空!', trigger: 'blur', pattern: /.+/ }
            ],
            endTime: [
                { required: true, message: '日期不能为空!', trigger: 'blur', pattern: /.+/ }
            ],
        };

    }
